import { useState } from "react";
import { Element } from "react-scroll";
import { ScrollLink } from "react-migration/domains/sites/card/Summary/components/ScrollLink";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { MapContainer } from "../Map";
import { Overview } from "react-migration/domains/sites/card/Summary/components/Overview";
import { Ownership } from "react-migration/domains/sites/card/Summary/components/Ownership";
import { SiteName } from "react-migration/domains/sites/card/Summary/components/SiteName";
import { Zoning } from "react-migration/domains/sites/card/Summary/components/Zoning";

export const Summary = () => {
  const [activeLink, setActiveLink] = useState<string>("");
  const { t } = useTranslation();
  const handleActiveLink = (to: string) => setActiveLink(to);

  return (
    <div data-test-id="summary-lite" className="flex atlas-h-full">
      <div className="atlas-w-1/2 atlas-h-full atlas-p-3">
        <MapContainer />
      </div>
      <div className="atlas-w-1/2 atlas-border-l atlas-border-border-divider atlas-h-full atlas-flex atlas-flex-col">
        <header className="atlas-p-4 atlas-pb-0 atlas-bg-background-dark atlas-border-b atlas-border-border-divider">
          <div className="atlas-font-medium atlas-text-lg atlas-leading-6 atlas-text-content-primary">
            {t("sites.card.summary_title")}
          </div>
          <SiteName />
          <nav
            data-testid="tab-header"
            className="flex atlas-border-t atlas-border-border-divider-subtle"
          >
            <ScrollLink
              to="overview"
              onSetActive={handleActiveLink}
              isActive={activeLink === "overview"}
              containerId="summary-scroll-container"
              labelTranslationKey="sites.card.summary_overview"
              noMargin
            />
            <ScrollLink
              to="ownership"
              onSetActive={handleActiveLink}
              isActive={activeLink === "ownership"}
              containerId="summary-scroll-container"
              labelTranslationKey="sites.card.summary_ownership"
            />
            <ScrollLink
              to="zoning"
              onSetActive={handleActiveLink}
              isActive={activeLink === "zoning"}
              containerId="summary-scroll-container"
              labelTranslationKey="sites.card.summary_zoning"
            />
          </nav>
        </header>
        <Element
          name="summary-scroll-container"
          id="summary-scroll-container"
          className="atlas-overflow-y-auto atlas-flex-1"
        >
          <Element name="overview">
            <div className="atlas-border-b atlas-border-border-divider">
              <Overview />
            </div>
          </Element>
          <Element name="ownership">
            <div className="atlas-border-b atlas-border-border-divider">
              <Ownership />
            </div>
          </Element>
          <Element name="zoning">
            <div className="atlas-border-b atlas-border-border-divider">
              <Zoning />
            </div>
          </Element>
        </Element>
      </div>
    </div>
  );
};
